import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { _className, ComponentSync } from '@nu-art/thunderstorm-frontend';
import { BadImplementationException, Debounce, Second } from '@nu-art/ts-common';
import { ModuleFE_FloatingWindows } from '../../_modules/ModuleFE_FloatingWindows.js';
import './TS_FloatingWindow.scss';
export class TS_FloatingWindow extends ComponentSync {
    static runningZIndex = 0;
    wrapperRef = React.createRef();
    anchorRef = React.createRef();
    focusTimeout;
    resizeDebouncer = new Debounce(() => this.onResize(), 100, 250);
    resizeObserver = new ResizeObserver(() => this.resizeDebouncer.trigger());
    dragOffset;
    //######################### Life Cycle #########################
    //Logic for programmatic focus
    __onFocusFloatingWindow = (windowKey) => {
        if (windowKey !== this.props.model.key)
            return;
        const wrapper = this.wrapperRef.current;
        if (!wrapper)
            return;
        wrapper.focus();
        wrapper.classList.add('focus');
        //Bring to foreground
        if (Number(wrapper.style.zIndex) !== TS_FloatingWindow.runningZIndex)
            wrapper.style.zIndex = `${++TS_FloatingWindow.runningZIndex}`;
        this.focusTimeout = setTimeout(() => {
            wrapper.classList.remove('focus');
            delete this.focusTimeout;
        }, Second);
    };
    componentDidMount() {
        const wrapper = this.getWrapperElement();
        //Focus the window when it first mounts
        wrapper.focus();
        this.resizeObserver.observe(wrapper);
    }
    componentWillUnmount() {
        clearTimeout(this.focusTimeout);
        this.resizeObserver.disconnect();
    }
    //######################### Logic #########################
    closeWindow = () => {
        ModuleFE_FloatingWindows.window.remove(this.props.model.key);
    };
    getClassName = () => {
        const model = this.props.model;
        return _className('ts-floating-window', model.resizable && 'resizable', model.className);
    };
    getStyle = () => {
        const model = this.props.model;
        return {
            left: model.rect.x,
            top: model.rect.y,
            width: model.rect.width,
            height: model.rect.height,
            zIndex: ++TS_FloatingWindow.runningZIndex,
        };
    };
    getWrapperElement = () => {
        const wrapper = this.wrapperRef.current;
        if (!wrapper)
            throw new BadImplementationException('Wrapper ref disconnected!');
        return wrapper;
    };
    getAnchorElement = () => {
        const anchorElement = this.anchorRef.current;
        if (!anchorElement)
            throw new BadImplementationException('Anchor ref disconnected!');
        return anchorElement;
    };
    //######################### Event Callbacks #########################
    onResize = () => {
        const wrapper = this.getWrapperElement();
        const model = this.props.model;
        const rect = wrapper.getBoundingClientRect();
        model.rect.x = rect.x;
        model.rect.y = rect.y;
        model.rect.height = rect.height;
        model.rect.width = rect.width;
    };
    //Logic for UI focus
    onFocus = () => {
        const wrapper = this.getWrapperElement();
        //Bring to foreground
        if (Number(wrapper.style.zIndex) !== TS_FloatingWindow.runningZIndex)
            wrapper.style.zIndex = `${++TS_FloatingWindow.runningZIndex}`;
    };
    onDragStart = (e) => {
        const anchor = this.getAnchorElement();
        const wrapper = this.getWrapperElement();
        anchor.addEventListener('pointermove', this.onDragMove);
        anchor.addEventListener('pointerup', this.onDragEnd);
        wrapper.classList.add('dragging');
        //Calc x & y offset from wrapper top-left corner
        this.dragOffset = {
            x: e.clientX - this.props.model.rect.x,
            y: e.clientY - this.props.model.rect.y,
        };
    };
    onDragMove = (e) => {
        const newX = e.clientX - (this.dragOffset?.x ?? 0);
        const newY = e.clientY - (this.dragOffset?.y ?? 0);
        this.props.model.rect.x = newX;
        this.props.model.rect.y = newY;
        const wrapper = this.getWrapperElement();
        wrapper.style.left = `${newX}px`;
        wrapper.style.top = `${newY}px`;
    };
    onDragEnd = () => {
        const anchor = this.getAnchorElement();
        const wrapper = this.getWrapperElement();
        anchor.removeEventListener('pointermove', this.onDragMove);
        anchor.removeEventListener('pointerup', this.onDragEnd);
        wrapper.classList.remove('dragging');
        delete this.dragOffset;
    };
    //######################### Render #########################
    render() {
        const model = this.props.model;
        return _jsxs("div", { ref: this.wrapperRef, className: this.getClassName(), style: this.getStyle(), tabIndex: 0, onFocus: this.onFocus, children: [this.render_DragAnchor(), model.content(this.closeWindow)] });
    }
    render_DragAnchor = () => {
        const model = this.props.model;
        if (!model.moveable)
            return;
        return _jsx("div", { ref: this.anchorRef, className: 'ts-floating-window__drag-anchor', onPointerDown: this.onDragStart });
    };
}
//# sourceMappingURL=TS_FloatingWindow.js.map